// Agrupa filas por una clave (ej: nombre del locador). Devuelve un array de
// [clave, items] ordenado alfabéticamente por clave. Mantiene el orden interno
// de `rows` dentro de cada grupo (respeta el sort de la tabla).
export const agruparPorClave = (rows, getKey) => {
  const map = new Map();
  for (const row of rows) {
    const key = getKey(row) || "—";
    if (!map.has(key)) map.set(key, []);
    map.get(key).push(row);
  }
  return [...map.entries()].sort((a, b) => a[0].localeCompare(b[0], "es"));
};
